import React from 'react';
export const DefaultImage = () => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 57 58"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: "54",
    height: "57",
    x: "3",
    y: "1",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M32.191 3.037c-6.754.997-13.922 4.578-19.874 10.53-3.572 3.572-6.29 7.584-8.108 11.674l-1.143-.507c1.882-4.235 4.69-8.373 8.367-12.05C17.556 6.56 24.963 2.84 32.01 1.8c7.045-1.04 13.773.597 18.433 5.257S56.74 18.446 55.7 25.491c-1.04 7.046-4.76 14.453-10.883 20.576-5.85 5.85-12.873 9.505-19.63 10.726s-13.29.015-18.084-3.922l.794-.966c4.444 3.65 10.579 4.83 17.067 3.658 6.486-1.172 13.282-4.693 18.97-10.38 5.951-5.952 9.532-13.12 10.529-19.874.997-6.755-.59-13.052-4.905-17.367-4.315-4.315-10.612-5.902-17.367-4.905Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "45.5",
    r: "15.5",
    fill: "#0021FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "36",
    cy: "27.5",
    r: "15",
    fill: "#116DFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "38",
    cy: "5.5",
    r: "14",
    fill: "#5FF2AE"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#C2E2FF",
    d: "M8.325 5.425a2.998 2.998 0 0 1-.85-1.675h-1.2c-.1.638-.4 1.213-.85 1.675-.45.463-1.037.75-1.675.85v1.2c.638.1 1.213.4 1.675.85.463.45.75 1.038.85 1.675h1.2c.1-.637.4-1.213.85-1.675A2.958 2.958 0 0 1 10 7.475v-1.2c-.637-.1-1.213-.4-1.675-.85ZM29.375 45C38.005 45 45 38.004 45 29.375c0-8.63-6.996-15.625-15.625-15.625-8.63 0-15.625 6.996-15.625 15.625C13.75 38.005 20.746 45 29.375 45ZM53.788 49.962a4.362 4.362 0 0 1-1.25-2.462h-1.313a4.4 4.4 0 0 1-1.25 2.462c-.675.663-1.525 1.113-2.462 1.25v1.313a4.4 4.4 0 0 1 2.462 1.25c.663.675 1.112 1.525 1.25 2.462h1.313a4.48 4.48 0 0 1 1.25-2.462 4.4 4.4 0 0 1 2.462-1.25v-1.313a4.4 4.4 0 0 1-2.462-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2E2FF",
    d: "M29.375 45C38.005 45 45 38.004 45 29.375c0-8.63-6.996-15.625-15.625-15.625-8.63 0-15.625 6.996-15.625 15.625C13.75 38.005 20.746 45 29.375 45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116DFF",
    d: "M25.85 31.65a14.164 14.164 0 0 1-4.013-7.9h-1.162a14.244 14.244 0 0 1-4.012 7.9 14.164 14.164 0 0 1-7.9 4.013v1.162a14.244 14.244 0 0 1 7.9 4.012 14.164 14.164 0 0 1 4.012 7.9h1.162a14.244 14.244 0 0 1 4.013-7.9 14.164 14.164 0 0 1 7.9-4.012v-1.163a14.244 14.244 0 0 1-7.9-4.012ZM42.5 17.5a6.772 6.772 0 0 1-1.913-3.75h-1.175A6.772 6.772 0 0 1 37.5 17.5a6.772 6.772 0 0 1-3.75 1.913v1.174A6.772 6.772 0 0 1 37.5 22.5a6.772 6.772 0 0 1 1.913 3.75h1.175A6.772 6.772 0 0 1 42.5 22.5a6.772 6.772 0 0 1 3.75-1.913v-1.174A6.772 6.772 0 0 1 42.5 17.5ZM8.75 55a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "35",
    height: "35",
    x: "0",
    y: "28",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7626_6075",
    stdDeviation: "1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: "54",
    height: "54",
    x: "9",
    y: ".5",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7626_6075",
    stdDeviation: "6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "54",
    height: "54",
    x: "11",
    y: "-21.5",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7626_6075",
    stdDeviation: "6.5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "translate(29.538 29.375) scale(26.4625)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".107",
    stopColor: "#6F56F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".359",
    stopColor: "#116DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".536",
    stopColor: "#fff",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".776",
    stopColor: "#19D1DF"
  }))));
};
//# sourceMappingURL=DefaultImage.js.map